import { Routes, Route } from 'react-router-dom'
import LandingPage from '@/pages/LandingPage'
import PrivacyTermsPage from '@/pages/PrivacyTermsPage'

function App() {
  return (
    <div className="min-h-screen">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy-terms" element={<PrivacyTermsPage />} />
      </Routes>
    </div>
  )
}

export default App